module.exports = __webpack_public_path__ + "img/luxury.65d961e.jpg";